/*eslint-disable*/
export default ({ external_id }) => {
  ((w, d, s, l, i) => {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start':
        new Date().getTime(), event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src =
      'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', external_id);

  const gctIframe = document.createElement('iframe');

  gctIframe.src = `https://www.googletagmanager.com/ns.html?id=${external_id}`;
  gctIframe.height = "0";
  gctIframe.width = "0";
  gctIframe.style.display = "none";
  gctIframe.style.visibility = "hidden";

  const gctNoscript = document.createElement('noscript');

  gctNoscript.appendChild(gctIframe);
  document.body.appendChild(gctNoscript);
};



// WEBPACK FOOTER //
// ./src/lib/tracking-integrations/gct.js